import React from 'react';
import classNames from 'classnames';
var css = {
  "bubble": "rui-9or2W",
  "background-background": "rui-Ro5E8",
  "position-left": "rui-YXGR4",
  "position-right": "rui-Kzkkd",
  "position-bottom": "rui-55Knn",
  "background-accentLight": "rui-8R5sn"
};
var Bubble = function Bubble(_ref) {
  var backgroundColor = _ref.backgroundColor,
    position = _ref.position,
    children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(css.bubble, css["background-".concat(backgroundColor)], css["position-".concat(position)], className),
    "data-aut-id": "bubble"
  }, children);
};
Bubble.defaultProps = {
  backgroundColor: 'background',
  position: 'left',
  className: ''
};
export default Bubble;